module.exports = __webpack_public_path__ + "representation.845584fb5ba3704c3d7c09f83e8d6e88.jpg";